export enum PersonPaymentType {
    PIX = "PIX",
    CASH = "DINHEIRO",
    CREDIT_CARD = "CARTÃO DE CRÉDITO",
    OTHER = "OUTRO"
}